// Export Auth Pages Paths
export const AuthPagesPath = {
  login: "/login",
};

// Export Main Paths
export const MainPagesPath = {
  schemes: "/schemes",
  scheme: "/scheme",
  userSchemes: "/userSchemes",
  uploadScheme: "/upload-scheme",
  updateScheme: "/update-scheme",
  allPromotions: "/allPromotions",
  uploadPromotion: "/upload-promotion",
  editPromotion: "/edit-promotion",
  allEditors: "/allEditors",
  machineModels: "/machineModels",
  modelDetails: "/modelDetails",
  machineVariants: "/machineVariants",
  variantDetails: "/variantDetails",
};
